var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconInPipelineCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 11.0781H11.0781V11.125V18.25C11.0781 18.5359 10.9645 18.8102 10.7623 19.0123C10.5602 19.2145 10.2859 19.3281 10 19.3281C9.71406 19.3281 9.43984 19.2145 9.23765 19.0123C9.03546 18.8102 8.92188 18.5359 8.92188 18.25V11.125V11.0781H8.875H1.75C1.46406 11.0781 1.18984 10.9645 0.987651 10.7623C0.785463 10.5602 0.671875 10.2859 0.671875 10C0.671875 9.71406 0.785463 9.43984 0.987651 9.23765C1.18984 9.03546 1.46406 8.92188 1.75 8.92188H8.875H8.92188V8.875V1.75C8.92188 1.46406 9.03546 1.18984 9.23765 0.987651C9.43984 0.785463 9.71406 0.671875 10 0.671875C10.2859 0.671875 10.5602 0.785463 10.7623 0.98765C10.9645 1.18984 11.0781 1.46406 11.0781 1.75V8.875V8.92188H11.125H18.25C18.5359 8.92188 18.8102 9.03546 19.0123 9.23765C19.2145 9.43984 19.3281 9.71406 19.3281 10C19.3281 10.2859 19.2145 10.5602 19.0123 10.7623C18.8102 10.9645 18.5359 11.0781 18.25 11.0781H11.125Z",
    fill: "#475569",
    stroke: "#475569",
    strokeWidth: 0.09375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconInPipelineCard);
export default __webpack_public_path__ + "static/media/PlusIconInPipelineCard.839304d854c5f354ee2d486211106e51.svg";
export { ForwardRef as ReactComponent };